import { ReactElement, Suspense } from 'react';
import PageLayout from '../../../components/PageLayout';
import MainContent from '../../../components/MainContent';
import SideBar from '../../../components/SideBar';
import Header from './components/Header';
import Loading from '../../../components/Loading';
import Content from './components/Content';

const AdvisorsListPage = (): ReactElement => (
  <PageLayout
    sidebar={<SideBar />}
    mainContent={
      <MainContent
        header={<Header title='営業担当者管理' />}
        content={
          <Suspense fallback={<Loading />}>
            <Content />
          </Suspense>
        }
      />
    }
  />
);

export default AdvisorsListPage;
